import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import { PentairIcon } from './pentair-icon';
export const PentairHeading = ({ contained, spacing, fullWidth, children, icon, ...props }) => {
    let renderIcon = null;
    if (icon && (typeof icon === 'string' || Array.isArray(icon) || 'iconName' in icon)) {
        renderIcon = _jsx(PentairIcon, { icon: icon });
    }
    else {
        renderIcon = icon;
    }
    if (props.paragraph || props.gutterBottom) {
        spacing = 'none';
    }
    if (spacing === 'dense') {
        if (contained) {
            props.paddingX = props.paddingX ?? 2;
            props.paddingY = props.paddingY ?? 0.66;
        }
        else {
            props.marginTop = props.marginTop ?? 0;
            props.marginBottom = props.marginBottom ?? 1;
        }
    }
    if (spacing === 'normal') {
        if (contained) {
            props.paddingX = props.paddingX ?? 2;
            props.paddingY = props.paddingY ?? 1;
        }
        else {
            props.marginTop = props.marginTop ?? 0;
            props.marginBottom = props.marginBottom ?? 2;
        }
    }
    if (contained) {
        return (_jsxs(Box, { component: Typography, bgcolor: '#eee', marginX: fullWidth ? -2 : undefined, align: "center", color: 'silverGray.main', display: props.display, gap: '1.1rem', ...props, children: [renderIcon, children] }));
    }
    return (_jsxs(Box, { component: Typography, fontWeight: 600, color: 'silverGray.main', ...props, alignItems: "center", display: "flex", gap: '1.1rem', children: [renderIcon, children] }));
};
PentairHeading.defaultProps = {
    variant: 'h4',
    spacing: 'normal',
};
